<div class="form-group has-feedback has-clear position-relative mb-3 vehicle-search-container">
  <label for="vehicleSearch" class="form-label">Vehicle</label>
  <input type="text"
         class="form-control"
         name="vehicleSearch"
         placeholder="Search vehicles"
         [(ngModel)]="model"
         [ngbTypeahead]="searchVehicles"
         [inputFormatter]="formatter"
         [resultTemplate]="rt"
         (focus)="focusVehicleSearch$.next($any($event).target.value)"
         (click)="clickVehicleSearch$.next($any($event).target.value)"
         (selectItem)="selectVehicle($any($event).item)"
         [editable]="false"
         #vehicleSearch="ngbTypeahead"/>

  <span class="form-control-clear fa-solid fa-times form-control-feedback" (click)="clearVehicle()"></span>
  <ng-template #rt let-r="result" let-t="term">
    <div><small><ngb-highlight [result]="r.manufacturer" [term]="t"></ngb-highlight></small></div>
    <div><ngb-highlight [result]="r.model" [term]="t"></ngb-highlight></div>
    <hr class="m-0" />
  </ng-template>
  </div>
